module.exports = __webpack_public_path__ + "img/verify.dd8833bf.jpg";